import script from "./CustomerForecastDiffLastMonth.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerForecastDiffLastMonth.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerForecastDiffLastMonth.vue?vue&type=style&index=0&id=7bde63c2&lang=scss&scoped=true"
import "./CustomerForecastDiffLastMonth.vue?vue&type=style&index=1&id=7bde63c2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bde63c2"]])

export default __exports__